export enum SORT_ORDER {
    NONE = '',
    ASCENDING = 'ASC',
    DESCENDING = 'DESC',
}
